import { Banner } from 'Components/shared/Banner';
import { MobXProviderContext, observer } from 'mobx-react';
import React from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { downloadDesktopApp } from 'Utils/globalUserActions';
import { getBannerVariantProps } from '../helpers/getBannerVariantProps';
import { BannerLayoutProps } from '../index.types';

export const UpdateAvailableBannerWrapper = observer(
  ({ variant }: BannerLayoutProps) => {
    const { ui } = React.useContext<RootStoreProps>(MobXProviderContext);

    return (
      <Banner
        isFullWidth
        type="info"
        id="update-banner-wrapper"
        message="A new version is available! Please update your Communicator to continue using all the latest features and improvements."
        showCloseButton={false}
        {...getBannerVariantProps(variant)}
        action={[
          {
            label: 'Dismiss',
            onClick: () => {
              ui.setShouldShowUpdateAvailableBanner(false);
            },
          },
          {
            label: 'Download',
            onClick: downloadDesktopApp,
          },
        ]}
      />
    );
  }
);
